// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-btn[data-v-7c7493c2]{background-image:linear-gradient(90deg,#c700de,#503af8);box-shadow:0 4px 8px rgba(0,0,0,.1);font-family:\"Catamaran\",sans-serif;font-size:16px;font-weight:400;letter-spacing:.03em;margin-top:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
